function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M120.78 82.32l17 9.79a9.79 9.79 0 013.58 13.37 9.79 9.79 0 01-13.37 3.58L85.6 84.59M119.47 104.18a9.79 9.79 0 013.53 13.37 9.79 9.79 0 01-13.37 3.58l-33.87-19.58"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M101.2 116.24a9.79 9.79 0 013.58 13.37 9.79 9.79 0 01-13.37 3.58l-1.13-.65-65.56-37.85-1.13-.65a39.16 39.16 0 01-14.34-53.5l9.79-17A39.16 39.16 0 0172.53 9.25l3.41 2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M147.52 75.16l1.22-2.12a39.16 39.16 0 00-14.33-53.49l-17-9.79A39.16 39.16 0 0064 24.09L37.63 67.93l7 2.63A12 12 0 0057 68.13l16.92-18.35c11.63 4.95 19.59 1.74 26.14-2l47.49 27.4a9.79 9.79 0 013.58 13.37 9.79 9.79 0 01-13.37 3.58L95.34 67.64"
});

var SvgDeals = function SvgDeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 158 138.5",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default SvgDeals;